import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import ArrowDownLeftIcon from '@atlaskit/icon/core/arrow-down-left';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context';
import { usePageContentId } from '@confluence/page-context';

import { useContentLinks } from '../hooks/useContentLinks';

import { DetailRow } from './DetailRow';
import { InlineRetryError } from './InlineRetryError';
import { SubtleLink } from './SubtleLink';

const i18n = defineMessages({
	incomingLinks: {
		id: 'details-panel.links-section.incoming-links-row',
		defaultMessage: 'Incoming links',
		description:
			'Text that appears next to a number indicating the number of incoming links on specific content',
	},
});

const linkLimit = 50;

export const IncomingLinksRow = () => {
	const { formatMessage } = useIntl();
	const [contentId] = usePageContentId();
	const { data, error, refetch, loading } = useContentLinks(linkLimit);
	const { incomingLinksCount, incomingLinksHasMore } = data;

	if (!incomingLinksCount && !error) {
		return <div data-testid="incoming-links-empty-row" />;
	}

	return (
		<UFOLoadHold name="incoming-links-details-panel-hold" hold={loading}>
			<DetailRow itemName={formatMessage(i18n.incomingLinks)} icon={<ArrowDownLeftIcon label="" />}>
				{error ? (
					<InlineRetryError error={error} refetch={refetch} />
				) : (
					<SubtleLink
						href={`${CONTEXT_PATH}/pages/viewinfo.action?pageId=${contentId}`}
						analyticsContext={{
							source: 'contentWrapper',
							attributes: {
								name: 'incomingLinks',
								count: incomingLinksCount,
								hasMore: incomingLinksHasMore,
							},
						}}
					>
						<div data-testid="incoming-links-count">
							{incomingLinksCount}
							{incomingLinksHasMore ? '+' : ''}
						</div>
					</SubtleLink>
				)}
			</DetailRow>
		</UFOLoadHold>
	);
};
